import { createDriverRoutesTypes } from "dora-contracts";
import * as t from "io-ts";

const {
  driverRoutesResponseT,
  driverRoutesResponseWithVersionT,
  driverRouteWaypointStopT,
  driverRouteCargoStopT,
  routeStartedEndedDataT,
  cargoT,
  stopT,
  stopAttachmentT,
} = createDriverRoutesTypes({
  decimal: t.string,
  date: t.string,
  dateTime: t.string,
});

export { driverRoutesResponseT, driverRoutesResponseWithVersionT };

export type CargoNew = t.TypeOf<typeof cargoT>;
export type RouteWaypointStopNew = t.TypeOf<typeof driverRouteWaypointStopT>;
export type RouteCargoStopNew = t.TypeOf<typeof driverRouteCargoStopT>;
export type RouteStopNew = RouteWaypointStopNew | RouteCargoStopNew;
export type StopNew = t.TypeOf<typeof stopT>;
export type DriverRoutesResponse = t.TypeOf<typeof driverRoutesResponseT>;
export type RouteStartedEndedData = t.TypeOf<typeof routeStartedEndedDataT>;
export type StopAttachment = t.TypeOf<typeof stopAttachmentT>;
